import React from 'react';
import { Alert, Button, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

interface AnswerCheckPanelProps {
  verdict: 'CORRECT' | 'INCORRECT' | 'PARTIAL';
  onRevealSolution: () => void;
  onDismiss: () => void;
}

/**
 * The follow-up shown after a CHECK_ANSWER verdict (spec 046 US4, FR-014). Feedback itself
 * streams onto the canvas like any other AI response; this small banner is only the
 * accept/decline choice for "want the correct solution?" after a wrong/partial answer.
 */
const AnswerCheckPanel: React.FC<AnswerCheckPanelProps> = ({ verdict, onRevealSolution, onDismiss }) => {
  if (verdict === 'CORRECT') {
    return (
      <Alert icon={<CheckCircleIcon fontSize="inherit" />} severity="success" onClose={onDismiss} sx={{ mb: 1 }}>
        Nicely done — that's correct.
      </Alert>
    );
  }

  return (
    <Alert
      icon={<ErrorOutlineIcon fontSize="inherit" />}
      severity={verdict === 'PARTIAL' ? 'warning' : 'error'}
      onClose={onDismiss}
      sx={{ mb: 1 }}
      action={
        <Stack direction="row" spacing={1}>
          <Button size="small" startIcon={<LightbulbIcon />} onClick={onRevealSolution} data-testid="gn-reveal-solution">
            Show correct solution
          </Button>
        </Stack>
      }
    >
      {verdict === 'PARTIAL' ? "You're partly there — see the notes above." : 'Not quite — see the notes above.'}
    </Alert>
  );
};

export default AnswerCheckPanel;
